import type { WatchlistPillData } from "../../@types/mapviewxs";

export interface Input {
  watchlistPillData?: WatchlistPillData;
  "on-watchlist-pill-click"?: () => void;
  selected: boolean;
}

export default class extends Marko.Component<Input> {
  onWatchlistPillClick() {
    this.emit("watchlist-pill-click");
  }
}
